import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from '@redux';
import { Button, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

const MarkAsSuccessModal = ({ onCancel, handleSubmit, loading }) => {
  const { t } = useTranslation();

  const modal = useSelector<DynamicObjectType>((state) => state.modal.modal);

  return (
    <Modal
      open={modal?.markAsSuccess?.isOpen}
      onCancel={onCancel}
      footer={null}
      width={443}
      closeIcon={false}
      closable={false}
    >
      <div className="grid gap-5">
        <div className="text-center text-[24px]">
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className="text-[--primary] mb-[5px]"
          />
          <div className="text-center text-base font-semibold">
            {t('orders.confirmMarkAsSuccess')}
          </div>
        </div>
        <div className="text-center text-[#53575D] text-sm">
          {t('orders.confirmMarkAsSuccessDescription')}
        </div>
        <div className="flex justify-center items-center gap-2.5">
          <Button className="h-[40px] w-[100px]" onClick={onCancel}>
            {t('button.cancel')}
          </Button>
          <Button
            className="h-[40px] w-[100px]"
            type="primary"
            onClick={handleSubmit}
            loading={loading}
          >
            {t('button.ok')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MarkAsSuccessModal;
